<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yraniG/tc-custom/9781460302767.jpg?1726519363528" alt="This image is the cover for the book Draycott Everlasting"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Draycott Everlasting
      </h1>
      <p class="bookDescription body article font2">
        <b>Love transcends time in a fan-favorite classic and a darkly seductive tale set at Draycott Abbey—from the <i>New York Times</i>–bestselling author.</b><br/><br/><i>Christmas Knight</i><br/><br/>As Christmas approaches, Hope O’Hara is in desperate straits: unless she can find paying guests for the house she has lovingly restored, she’ll lose it to creditors. Enter one literal knight in shining armor—valiant and virile Ronan MacLeod, who is swept seven hundred years through time to save Hope from a potentially fatal accident . . . and to discover a passion for the ages.<br/><br/><i>Moonrise</i><br/><br/>Devastated by a colleague’s death and drawn to a thirteenth-century mystery, FBI agent Sara Nightingale arrives at Draycott Abbey for research and a much-needed getaway. Only, there she meets Navarre, a warrior from the Crusades who has been sent forth to avenge the guardian ghost of the abbey. Navarre and Sara cannot deny the centuries-old connection they feel . . . or the danger that surfaces from both the past and the present.<br/><br/><b>Praise for Christina Skye and the Draycott Abbey series</b><br/><br/>“Fast-paced action, vivid detail, a touch of the paranormal, and hot lovemaking will please readers of adventure romance, while fans of Skye’s Draycott Abbey and Code Name series will enjoy this clever union of the two.” —<i>Booklist</i> on <i>To Catch a Thief</i><br/><br/><br/><br/>“Christina Skye’s delightfully haunting Draycott Abbey tales . . . pass the test of time, as they remain some of the better romantic fantasies available.” —Harriet Klausner
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christina Skye
      </h2>
      
      <p class="authorDescription body article">Christina Skye loves a good adventure. Living in Arizona gives her plenty of room to practice target shooting and to trek off-road on her motorcycle, researching the details for stories rich with &ldquo;snappy dialogue&rdquo; and an unerring ability to keep &ldquo;the narrative energy high and the pacing swift&rdquo; (Publishers Weekly). With over two million books in print, her novels appear regularly on national bestseller lists. Visit her online at www.christinaskye.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23798b6a